export default [
  {
    path: '/b2bhub/Account/VisualizarCliente',
    name: 'visualizar-cliente',
    component: () => import('@/views/app/PTC/CadastroCliente/viewCadastroCliente.vue'),
    meta: {
      pageTitle: 'Visualização/Edição dos dados do cliente',
      action: 'read',
      resource: 'Acesso_CadastroCliente',
    },

  },
];
